import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

export const usePromocode = () => {
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: string) => {
      const response = fetch<{
        promoCodeId: string;
        promoCodeAmount: number;
        validTo: string;
      }>(`${Urls.PromoCode}`, {
        method: "POST",
        body: JSON.stringify({
          promocodeId: data
        }),
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      });

      return response;
    },
    onError: (error) => {
      toast.error(error?.message || "Error validating promo code");
    },
  });
};
